module.exports = __webpack_public_path__ + "img/T2C_rc_0.724fbc98.png";